const clamp = value => Math.min(Math.max(value, 0), 100);

export function getPilotGaugeProgress(value, forecast, objective) {
  const safeObjective = Math.max(Number(objective) || 0, 0);
  const realizedPercent = safeObjective ? Math.round((Math.max(Number(value) || 0, 0) / safeObjective) * 100) : 0;
  const forecastPercent = safeObjective ? Math.round((Math.max(Number(forecast) || 0, 0) / safeObjective) * 100) : 0;
  return {
    safeObjective,
    realizedPercent,
    forecastPercent,
    realizedPosition: clamp(realizedPercent),
    forecastPosition: clamp(forecastPercent),
  };
}
